<template>
  <div
    :class="{'route-points__container--empty': props.points.length === 0}"
    class="route-points__container"
  >
    <DataTable
      :value="props.points"
      :row-class="() => 'row-container'"
      @row-reorder="reorderPoints"
    >
      <!-- Columns -->
      <Column
        row-reorder
        class="reorder-desktop"
      >
        <template #reordericon>
          <i class="pi pi-arrows-alt"></i>
        </template>
      </Column>
      <Column class="reorder-mobile">
        <template #body="{ index }">
          <Button
            v-if="!!index"
            v-tooltip.bottom="'Subir punto'"
            icon="pi pi-arrow-up"
            @click="reorderPoints({dragIndex: index, dropIndex: index - 1})"
          />
        </template>
      </Column>
      <Column class="reorder-mobile">
        <template #body="{ index }">
          <Button
            v-if="index < (props.points.length - 1)"
            v-tooltip.bottom="'Bajar punto'"
            icon="pi pi-arrow-down"
            @click="reorderPoints({dragIndex: index, dropIndex: index + 1})"
          />
        </template>
      </Column>
      <Column
        field="name"
        header="Nombre"
      />
      <Column
        field="province"
        header="Provincia"
      />
      <Column
        field="category"
        header="Categoría"
      />
      <Column>
        <template #body="{ data }">
          <Button
            v-tooltip.bottom="'Eliminar punto'"
            icon="pi pi-times"
            @click="removeRoutePoint(data.id)"
          />
        </template>
      </Column>
      <template #footer>
        <div
          class="search-actions flex md:flex-row justify-content-start p-2"
          style="width: 100%"
        >
          <div>
            <Button
              v-tooltip.bottom="'Calcula la ruta más rápida'"
              class="m-2 mc-action__button"
              icon="pi pi-car"
              label="Ruta más rápida"
              :disabled="props.points.length < 2"
              @click="calculateFastestRoute"
            />
          </div>
          <div>
            <Button
              v-tooltip.bottom="'Calcula la ruta más corta'"
              class="m-2 mc-action__button"
              icon="pi pi-globe"
              label="Ruta más corta"
              :disabled="props.points.length < 2"
              @click="calculateShortestRoute"
            />
          </div>
          <div>
            <Button
              v-tooltip.bottom="'Elimina todos los puntos de paso'"
              class="m-2 mc-action__button"
              icon="pi pi-trash"
              label="Limpiar puntos"
              :disabled="!props.points.length"
              @click="removeAllPoints"
            />
          </div>
        </div>
      </template>
    </DataTable>
  </div>
</template>

<script setup>
// import {ref} from 'vue';
import {useStore} from 'vuex';
import Button from 'primevue/button';
import DataTable from 'primevue/datatable';
import Column from 'primevue/column';

// #region Props, Emits

const props = defineProps({
  points: {
    type: Array,
    default: () => [],
  },
});
const emit = defineEmits([
  'calculateShortestRoute',
  'calculateFastestRoute',
  'removeRoutePoint',
  'removeAllPoints',
]);
// #endregion

// #region Params, Ref, Reactives, Computed

const store = useStore();
// #endregion

// #region Functions
async function reorderPoints({dragIndex: fromIndex, dropIndex: toIndex}) {
  await store.dispatch('calcRoute/reorderRoutePoints', {
    fromIndex,
    toIndex,
  });
}
async function removeRoutePoint(id) {
  emit('removeRoutePoint', id);
}
function removeAllPoints() {
  emit('removeAllPoints');
}
function calculateFastestRoute() {
  emit('calculateFastestRoute');
}
function calculateShortestRoute() {
  emit('calculateShortestRoute');
}
// #endregion

// #region Effects, Hooks

// #endregion

// #region Provide, Expose

// #endregion
</script>

<style lang="scss" scoped>
@import "src/styles";

.route-points {
  &__container {
    & :deep(.p-datatable-table) {
      border-collapse: separate;
      border-spacing: 0 8px;
    }
    & :deep(.row-container) {
      border: .5px solid #ccc;
      background-color: $container-background-gray;
      border-radius: 8px;
    }
    &.route-points__container--empty {
      & :deep(.p-datatable-thead) {
        display: none;
      }
    }
    & :deep(.reorder-desktop) {
      @include max-screen-width($brand__breakpoint--md) {
        display: none;
      }
    }
    & :deep(.reorder-mobile) {
      @include min-screen-width($brand__breakpoint--md) {
        display: none;
      }
    }
  }
}
</style>
